<template>
    <v-card min-width="21vw" align="center" justify="center" light outlined>
        <v-card-title style="background-color: #d2d7e1">
            <v-list-item>
                <v-list-item-title><h3>{{ user.user.firstName }}'s Pro Expiration Date</h3></v-list-item-title>
                <v-spacer/>
                <v-list-item-action><v-icon class="icon" @click="closeWindow" icon>fa-times</v-icon></v-list-item-action>
            </v-list-item>
        </v-card-title>
        <v-card-text class="pa-5">
            <v-form v-model="valid">
                <p>Pro expiration date of <b>{{ user.user.firstName }} {{ user.user.lastName }}</b></p>
                <v-date-picker v-model="proExpirationDateString" color="green lighten-1"/>
                <v-select label="Type of Pro" style="width: 77%" class="mt-4 text-start justify-start" :items="proTypes" v-model="proType" dense outlined/>
                <div class="mb-3">
                    <v-btn class="mr-5" @click="changeProExpirationDate">Change Pro Time</v-btn>
                    <v-btn @click="closeWindow">Close</v-btn>
                </div>
            </v-form>
        </v-card-text>
    </v-card>
</template>

<script>
    import Repository from '../../repositories/users';
    export default {
        name: "EditUser",
        props: {
            user: Object,
        },
        data() {
            return {
                valid: false,

                // Values
                proExpirationDateString: null,
                proExpirationDate: null,
                proTypes: [
                  'NEVER_PRO',
                  'MONTHLY_PRO',
                  'ANNUALLY_PRO',
                  'LIFETIME_PRO',
                  'COMMUNITY_PRO',
                  'GIFTED_PRO',
                  'WAS_PRO',
                ],
                proType: 'GIFTED_PRO',
            };
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.proType = this.user.commercialState;
                this.proExpirationDate = this.user.proExpirationDate;
                this.proExpirationDateString = this.proExpirationDate.substr(0, 10);
            },
            changeProExpirationDate() {
                let dateArray = this.proExpirationDateString.split('-');
                console.log(this.proExpirationDateString);
                let proTime = {
                    userId: this.user.user.id,
                    newDate: new Date(Number.parseInt(dateArray[0]), (Number.parseInt(dateArray[1]) - 1), Number.parseInt(dateArray[2])),
                    commercialState: this.proType,
                };

                if(proTime.newDate < new Date() && !(this.proType === 'NEVER_PRO' || this.proType === 'WAS_PRO')) {
                    alert(`You cannot!\nPro Time for ${this.user.user.firstName} is set before today and the Pro Type MUST be NEVER_PRO or WAS_PRO`);
                    return;
                }
                if(proTime.newDate > new Date() && (this.proType === 'NEVER_PRO' || this.proType === 'WAS_PRO')) {
                    alert(`You cannot!\nPro Time for ${this.user.user.firstName} is set after today and the Pro Type CANNOT be NEVER_PRO or WAS_PRO`);
                    return;
                }

                Repository.changeProExpirationDate(proTime).then((response) => {
                    if(response.status < 400 && response.data) {
                        alert(`${this.user.user.firstName} Pro Time was successfully updated`);
                        this.user.proExpirationDate = this.proExpirationDateString;
                        this.user.commercialState = this.proType;
                        this.closeWindow();
                    }
                });
            },
            closeWindow() {
                this.$emit('closeWindow');
            },
        }
    }
</script>

<style scoped>

</style>
